<template>
  <module-page v-bind="pageParams">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs class="page__tabs" hide-slider>
          <v-tab
            :key="i"
            :to="tab.value"
            v-for="(tab, i) in pageParams.tabs"
            :active-class="`white--text ${
              hasLateSlips ? 'error--background' : 'financial--background'
            }`"
          >
            {{ !mobile ? tab.title : tab.titleMobile }}
            <i
              v-if="hasLateSlips && tab.icon"
              :class="`${tab.icon} side-text--icon`"
            />
          </v-tab>
        </v-tabs>
        <div class="payment-slip-in-delay__description">{{ description }}</div>
        <screen-loading v-if="loadingItems"></screen-loading>
        <empty-state-card
          v-else-if="error"
          icon="alert"
          errorType="genericError"
        >
          <div
            slot="message"
            v-html="error !== true ? error : $t('responses.error')"
          />
        </empty-state-card>
        <div v-else class="page-success">
          <template
            v-if="
              !hasLateSlips && Object.keys(solicitationsByContract).length === 0
            "
          >
            <empty-state-card
              :icon="enums.paymentSlipWaitingState.icon"
              errorType="emptySlips"
            >
              <div
                slot="message"
                v-html="$t('pages.paymentSlip.emptyLateSlips')"
              />
            </empty-state-card>
          </template>
          <template
            v-else-if="
              debitBlock ||
              (!inDelaySolicitationAllowed && !hasSolicitationsInProgress)
            "
          >
            <empty-state-card icon="alert" errorType="operationNotAllowed">
              <div slot="message" class="error--color">
                <p class="waiting-state__title">
                  <span>
                    <b>{{ $t('pages.paymentSlip.operationNotAllowed') }}</b>
                  </span>
                </p>
                <p class="waiting-state__text">
                  <span>{{
                    $t('pages.paymentSlip.partialSlipWarningSubTitle')
                  }}</span>
                </p>
                <p class="waiting-state__text">
                  <router-link
                    v-if="ticketCrmEnabled"
                    :to="{ name: 'ticketForm' }"
                    class="error--color font-weight-bold"
                    tag="a"
                  >
                    <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                  </router-link>
                </p>
              </div>
            </empty-state-card>
          </template>
          <template v-else-if="parcelTypesNotValid">
            <empty-state-card
              :icon="enums.paymentSlipWaitingState.icon"
              errorType="parcelTypesNotValid"
            >
              <div slot="message" class="error--color">
                <p class="payment-slip__late__info late">
                  <i class="payment-slip__late__icon bexsicon-alert icon"></i>
                  <span
                    >{{ $t('pages.paymentSlip.notPayableLateMessage') }}
                    <router-link
                      v-if="ticketCrmEnabled"
                      :to="{ name: 'ticketForm' }"
                      class="error--color font-weight-bold"
                      tag="a"
                    >
                      <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                    </router-link>
                  </span>
                </p>
              </div>
            </empty-state-card>
          </template>
          <template v-else>
            <empty-state-card messagePadding="2%" messageClass="xs12 md12 lg12">
              <template slot="message">
                <span class="payment-slip-in-delay__febraban font-weight-bold">
                  {{ latePaymentSlipTooltip }}
                </span>
              </template>
            </empty-state-card>
            <span v-for="(contract, i) in allowedContracts" :key="i">
              <v-card
                v-if="
                  latePositionData[contract.id] === null ||
                  latePositionData[contract.id]['late'] ||
                  solicitationsByContract[contract.id]
                "
                class="mt-2 mb-2"
              >
                <v-card-title class="pt-headline financial--color">{{
                  getContractTitle(contract)
                }}</v-card-title>
                <screen-loading
                  v-if="latePositionData[contract.id]['late'] === null"
                  margin="20px 25%"
                ></screen-loading>
                <v-card-text v-else>
                  <p
                    v-if="
                      config.texts.lateSlipDetachedContractMessage &&
                      contract.type === enums.contractValues.detached
                    "
                    class="payment-slip-in-delay__description"
                    style="margin: 2px 18px"
                  >
                    {{ config.texts.lateSlipDetachedContractMessage }}
                    <router-link
                      v-if="ticketCrmEnabled"
                      style="color: var(--financial-color); font-weight: bold"
                      :to="{ name: 'ticketForm' }"
                      tag="a"
                    >
                      <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                    </router-link>
                  </p>

                  <empty-state-card
                    v-if="
                      !inDelaySolicitationAllowed &&
                      selectedStep[contract.id] === '1'
                    "
                    icon="alert"
                    errorType="operationNotAllowed2"
                  >
                    <div slot="message" class="error--color">
                      <p class="waiting-state__title">
                        <span>
                          <b>{{
                            $t('pages.paymentSlip.operationNotAllowed')
                          }}</b>
                        </span>
                      </p>

                      <p class="waiting-state__text">
                        <span>{{
                          $t('pages.paymentSlip.partialSlipWarningSubTitle')
                        }}</span>
                      </p>

                      <p class="waiting-state__text">
                        <router-link
                          v-if="ticketCrmEnabled"
                          class="error--color font-weight-bold"
                          :to="{ name: 'ticketForm' }"
                          tag="a"
                        >
                          <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                        </router-link>
                      </p>
                    </div>
                  </empty-state-card>
                  <div v-else class="table-stepper-container">
                    <template
                      v-if="
                        (!solicitationsByContract[contract.id] ||
                          solicitationsByContract[contract.id].length == 0) &&
                        (!latePositionData[contract.id] ||
                          latePositionData[contract.id]['late'].length == 0)
                      "
                    >
                      <empty-state-card
                        :icon="enums.paymentSlipWaitingState.icon"
                      >
                        <div slot="message">
                          <p class="waiting-state__title">
                            <span>
                              <b>{{ pageParams.emptyState.late }}</b>
                            </span>
                          </p>
                        </div>
                      </empty-state-card>
                    </template>
                    <table-stepper
                      v-else-if="!systemDischarge[contract.id]"
                      v-model="selectedStep[contract.id]"
                      v-bind="enums.paymentSlipRequestSteps"
                      :no-data-text="pageParams.emptyState.late"
                      :items="
                        solicitationsByContract[contract.id] &&
                        solicitationsByContract[contract.id].length > 0
                          ? solicitationsByContract[contract.id]
                          : latePositionData[contract.id]['late'] || []
                      "
                      :loading="loadingApp"
                      :headers="
                        selectedStep[contract.id] === '1'
                          ? slipSelectionHeaders
                          : solicitationReadyHeaders
                      "
                      :financialPosition="latePositionData[contract.id]"
                      :unitFinancialPositions="latePositionData"
                      :expand-column="expandColumn"
                      :slipDetailsHeaders="slipDetailsHeaders"
                      mode="late"
                      @updateSelected="
                        (v) => {
                          selected[contract.id] = v;
                        }
                      "
                      buttonClass="white--text financial--background"
                      totalKey="discountedValue"
                      totalLabel="Total"
                      sort-icon="bexsicon-down"
                      itemKey="id"
                      :buttonText="enums.paymentSlipRequestButtonText"
                      @buttonClicked="solicitateSlip(contract.id)"
                      :buttonLoading="loadingSolicitation"
                      :activeClass="`
                      financial--background
                      financial--border-color
                      all--white`"
                    >
                      <template #col-discountedValue="props">
                        <span class="financial__discounted-value">
                          {{
                            formatMoney(
                              !(props.item.contractQty >= 2)
                                ? props.item.discountedValue
                                : props.item[expandColumn].total
                            )
                          }}
                        </span>
                      </template>
                      <template slot="firstStepTableItems" slot-scope="props">
                        <td class="text-xs-center">
                          {{ formatDate(props.item.expirationDate) }}
                        </td>
                        <td class="text-xs-center bold--text">
                          {{ formatMoney(props.item.discountedValue) }}
                        </td>
                        <td v-if="!mobile" class="text-xs-center"></td>
                      </template>
                      <template slot="secondStepTableItems">
                        <empty-state-card
                          :icon="enums.paymentSlipWaitingState.icon"
                        >
                          <div slot="message">
                            <p
                              :class="`waiting-state__title ${
                                solicitationErrors[contract.id]
                                  ? 'error--text'
                                  : ''
                              }`"
                            >
                              {{
                                $t(
                                  enums[
                                    solicitationErrors[contract.id]
                                      ? 'paymentSlipError'
                                      : 'paymentSlipWaitingState'
                                  ].title
                                )
                              }}
                            </p>
                            <p class="waiting-state__text">
                              {{
                                $t(
                                  enums[
                                    solicitationErrors[contract.id]
                                      ? 'paymentSlipError'
                                      : 'paymentSlipWaitingState'
                                  ].firstLine,
                                  { slipTimeoutHours }
                                )
                              }}
                              <router-link
                                v-if="
                                  ticketCrmEnabled &&
                                  solicitationErrors[contract.id]
                                "
                                :to="{ name: 'ticketForm' }"
                                tag="a"
                              >
                                <u>{{ $t(enums.paymentSlipError.link) }}</u>
                              </router-link>
                            </p>
                          </div>
                        </empty-state-card>
                      </template>
                      <template slot="thirdStepTableItems" slot-scope="props">
                        <td class="text-xs-center">
                          {{ formatDate(props.item.expirationDate) }}
                        </td>
                        <td class="text-xs-center bold--text">
                          {{ formatMoney(props.item.paymentTotal) }}
                        </td>
                        <td class="text-xs-center">
                          <PaymentButton
                            v-if="
                              !props.item.unified || props.item.unified.payable
                            "
                            :item="props.item"
                            :email="email"
                            :cellphone="cellphone"
                            :buttonClass="'financial--background table-btn'"
                            @openSlip="paySlip(props.item)"
                            :sendByEmail="sendSlipByEmailLate"
                            :sendBySms="sendSlipBySmsLate"
                          >
                            <template v-slot:tooltip>
                              <v-tooltip
                                z-index="99"
                                top
                                color="grey lighten-3"
                                max-width="300"
                              >
                                <span class="tooltip__text no-print">{{
                                  latePaymentSlipTooltip
                                }}</span>
                                <span slot="activator">
                                  <i
                                    class="bexsicon-info tooltip__icon indelay-slips-tooltip"
                                  />
                                </span>
                              </v-tooltip>
                            </template>
                          </PaymentButton>
                        </td>
                      </template>
                    </table-stepper>
                    <template v-else>
                      <empty-state-card icon="alert">
                        <div slot="message">
                          <p class="waiting-state__title">
                            <span>
                              <b>
                                Estamos aguardando o pagamento do boleto gerado
                                {{
                                  solicitationsByContract[contract.id]
                                    ? ' com vencimento no dia ' +
                                      formatDate(
                                        solicitationsByContract[contract.id]
                                          .expirationDate
                                      )
                                    : ''
                                }}.
                              </b>
                            </span>
                          </p>
                          <p class="waiting-state__text">
                            <span>{{
                              $t('pages.paymentSlip.waitingMessage')
                            }}</span>
                          </p>
                          <p class="waiting-state__text">
                            <router-link
                              v-if="ticketCrmEnabled"
                              class="financial--color font-weight-bold"
                              :to="{ name: 'ticketForm' }"
                              tag="a"
                            >
                              <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                            </router-link>
                          </p>
                        </div>
                      </empty-state-card>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </span>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import TableStepper from '@/components/financial/TableStepper';
import EmptyStateCard from '@/components/layout/EmptyStateCard';
import PaymentButton from '@/components/financial/PaymentButton';
// import latePaymentSlipMixin from '@/mixins/modules/latePaymentSlip';
import notificationTypes from '@/utils/notificationTypes';
import getSlipUrl from '@/services/getSlipUrl';
import {
  APP,
  CONFIG,
  NOTIFICATIONS,
  ROLES,
  SOLICITATE_TYPE,
  USER,
  PARCEL_TYPES,
  TICKET_CRM,
  UNIT,
} from '../../utils/constants';

export default {
  name: 'latePaymentSlip',
  components: {
    ModulePage,
    ScreenLoading,
    TableStepper,
    EmptyStateCard,
    PaymentButton,
  },
  // mixins: [latePaymentSlipMixin],
  computed: {
    latePositionData() {
      return this.$store.getters['lateSlips/latePositionData'];
    },
    unitSolicitations() {
      return this.$store.getters['lateSlips/solicitations'];
    },
    hasLateSlips() {
      return this.$store.getters['lateSlips/hasLateSlips'];
    },
    inDelaySolicitationAllowed() {
      return this.$store.getters['lateSlips/inDelaySolicitationAllowed'];
    },
    imobmeUser() {
      return this.$store.getters[USER.GET_IMOBME_DATA];
    },
    ticketCrmEnabled() {
      return this.$store.getters[TICKET_CRM.GET_ENABLED];
    },
    hasSolicitationsInProgress() {
      return this.selectedUnit.contracts.find(
        (o, i) => this.solicitationsByContract[o.id]
      );
    },
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    debitBlock() {
      return this.$store.getters[UNIT.GET_DEBIT_BLOCK];
    },
    allowedContracts() {
      const { LATE_SLIPS } = enums.financialModules;
      return this.getAllowedContracts(LATE_SLIPS, this.selectedUnit.contracts);
    },
    latePaymentSlipTooltip() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .latePaymentSlipTooltip;
    },
    slipTimeoutHours() {
      return this.$store.getters[CONFIG.GET_SLIP_TIMEOUT_HOURS];
    },
    slipSelectionHeaders() {
      return this.visibleHeaders(this.slipSelectionHeadersConfig);
    },
    solicitationReadyHeaders() {
      return this.visibleHeaders(this.solicitationReadyHeadersConfig);
    },
    slipDetailsHeaders() {
      return this.visibleHeaders(this.slipDetailsHeadersConfig);
    },
  },
  data() {
    return {
      expandColumn: 'slipsUnion',
      parcelTypesNotValid: false,
      pageParams: this.$store.getters[APP.PAGES].paymentSlip,
      loadingSolicitation: false,
      description: '',
      selectedStep: {},
      solicitationsByContract: {},
      selected: {},
      solicitationErrors: {},
      // hasLateSlips: false,
      error: null,
      loadingItems: false,
      systemDischarge: {},
      solicitationReadyHeadersConfig: [
        {
          text: this.$t('pages.paymentSlip.expirationDate'),
          formatter: this.formatUtcDate,
          value: 'expirationDate',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('pages.paymentSlip.discountedValue'),
          value: 'discountedValue',
          // formatter: (v, item, headerValue) =>
          //   this.formatUnifiedValue(v, item, headerValue),
          align: 'center',
          sortable: false,
        },
        { text: '', value: '', align: 'center', sortable: false },
      ],
      slipSelectionHeadersConfig: [
        {
          text: '',
          value: 'selected',
          align: 'center',
          class: 'no-print',
          sortable: false,
          width: '40px',
        },
        {
          text: ' ',
          value: 'slipsUnion',
          align: 'left',
          class: 'no-print',
          sortable: false,
          width: '40px',
        },
        {
          text: this.$t('pages.paymentSlip.expirationDate'),
          formatter: this.formatUtcDate,
          value: 'expirationDate',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('pages.paymentSlip.discountedValue'),
          formatter: (v, item, headerValue, extraInfo) =>
            extraInfo == 'slipsUnion'
              ? this.formatMoney(v, item, headerValue, extraInfo)
              : this.formatUnifiedValue(v, item, headerValue, extraInfo),
          value: 'discountedValue',
          align: 'center',
          sortable: false,
          required: true,
        },
        { text: '', value: '', align: 'center', sortable: false },
      ],
      slipDetailsHeadersConfig: [
        {
          text: 'Contrato',
          value: 'type',
          align: 'center',
          showMobile: true,
        },
        {
          text: 'Descrição',
          value: 'contractTitle',
          formatter: (v, item) => this.getContractTitle(item),
          align: 'center',
          showMobile: false,
        },
        {
          text: 'Total',
          value: 'partialValue',
          align: 'center',
          formatter: this.formatMoney,
        },
      ],
      email: '',
      cellphone: {
        countryCode: '+55',
        areaCode: '',
        number: '',
      },
    };
  },
  created() {
    bus.$on('unit:change', this.setItems);
    bus.$on('unit:update', this.setItems);

    this.email = this.user.email;
    if (this.imobmeUser && this.imobmeUser.cellphone) {
      const { number, areaCode, countryCode } = this.imobmeUser.cellphone;
      this.cellphone = { number, areaCode, countryCode: countryCode || '+55' };
    }

    this.description = this.pageParams.texts.inDelayDescription;

    this.setItems();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.setItems);
    bus.$off('unit:update', this.setItems);
  },
  methods: {
    visibleHeaders(headers, mobile = this.mobile) {
      return headers.filter((header) =>
        mobile ? header.showMobile !== false : header.showDesktop !== false
      );
    },
    setItems(unitObj = null) {
      this.formatSelecteds();
      this.getItems();
    },

    formatSelecteds() {
      for (const { id } of this.selectedUnit.contracts) {
        this.selectedStep[id] = '1';
      }
    },

    async sendSlipByEmailLate(item, email, fromHome = false) {
      await this.$store.dispatch('lateSlips/sendSlipByEmail', {
        item,
        email,
        fromHome,
      });
    },
    async sendSlipBySmsLate(item, cellphone, fromHome = false) {
      await this.$store.dispatch('lateSlips/sendSlipBySms', {
        item,
        cellphone,
        fromHome,
      });
    },

    paySlip(slip) {
      if (slip.slipUrl.hash) {
        window.open(getSlipUrl(slip.slipUrl.hash));
      } else {
        window.open(slip.slipUrl);
      }

      const notification = {
        id: slip._id,
        type: notificationTypes.LATE_SLIPS,
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, {
        ctx: this,
        notification,
      });
      const contract = this.selectedUnit.contracts.find(
        ({ id }) => id === slip.contractId
      );
      const traceInfo = {
        contractId: slip.contractId,
        contractType: contract.type,
        detachedType: this.getContractTitle(contract),
        paymentTotal: slip.paymentTotal,
        solicitationCode: slip.solicitationCode,
        expirationDate: slip.expirationDate,
        parcels: slip.parcels,
        url: slip.slipUrl,
      };
      const traceAction = enums.logTraceActions.latePaymentSlipDownload;
      this.createTrace(traceAction, traceInfo);
    },

    async solicitateSlip(contractId) {
      if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
      if (this.loadingSolicitation) return;
      try {
        this.loadingSolicitation = true;

        const selectedSlips = this.selected[contractId];

        if (!selectedSlips || selectedSlips.length === 0) return;

        const solicitationContract = this.selectedUnit.contracts.find(
          ({ id }) => id === contractId
        );

        const unifiedSlips = [
          ...selectedSlips.flatMap(
            ({
              noChargeValue,
              discountedValue,
              parcelCode,
              serieId,
              serieCode,
              id,
              expirationDate,
              spe,
              contractQty,
              slipsUnion,
            }) => {
              let sameDocument = [
                {
                  noChargeValue,
                  discountedValue,
                  parcelCode,
                  serieId,
                  serieCode,
                  id,
                  expirationDate,
                  spe,
                },
              ];
              if (contractQty >= 2) {
                for (const slipContract of slipsUnion.contracts) {
                  if (slipContract.contractId != contractId) {
                    let contractSlips =
                      this.latePositionData[slipContract.contractId]['late'];
                    for (const otherSlip of slipContract.slips) {
                      let slip = contractSlips.find(
                        (s) =>
                          s.serieId === otherSlip.serieId &&
                          s.parcelCode === otherSlip.parcelCode
                      );
                      if (slip) {
                        sameDocument.push({
                          noChargeValue: slip.noChargeValue,
                          discountedValue: slip.discountedValue,
                          parcelCode: slip.parcelCode,
                          serieId: slip.serieId,
                          serieCode: slip.serieCode,
                          id: slip.id,
                          expirationDate: slip.expirationDate,
                          spe: slip.spe,
                        });
                      }
                    }
                  }
                }
              }
              return sameDocument;
            }
          ),
        ];

        const body = {
          contractId,
          contractType: solicitationContract.type,
          productSku: this.selectedUnit.sku,
          parcels: unifiedSlips,
          solicitationType: SOLICITATE_TYPE.LATE,
        };

        const solicitationResults = await this.requestService(
          `${process.env.FINANCIAL_API_URL}/solicitation/save`,
          'POST',
          {
            data: body,
            localErrorHandling: true,
            retries: 0,
          }
        );

        for (const result of solicitationResults) {
          if (result) {
            const unitContract = this.selectedUnit.contracts.find(
              ({ id }) => id === result.contractId
            );
            this.selectedStep[result.contractId] = '2';

            const traceAction =
              enums.logTraceActions.latePaymentSlipSolicitation;
            const traceInfo = {
              contractId: result.contractId,
              contractType: unitContract.type,
              detachedType: this.getContractTitle(unitContract),
              paymentTotal: result.paymentTotal,
              solicitationCode: result.solicitationCode,
              expirationDate: result.expirationDate,
              parcels: selectedSlips,
            };
            this.createTrace(traceAction, traceInfo);
          }
        }
        await this.$store.dispatch('lateSlips/resetLateSlipsCache');
        await this.getItems();
      } catch (e) {
        if (e.data.message === 'There is an ongoing solicitation') {
          await this.$store.dispatch('lateSlips/resetLateSlipsCache');
          this.getItems(false);
          this.error = this.$t('pages.paymentSlip.ongoingSolicitationError');
          this.showErrorToast(
            this.$t('pages.paymentSlip.ongoingSolicitationError')
          );
        } else if (e.status === 500) {
          this.error = this.$t('pages.paymentSlip.error.title');
        }
      } finally {
        this.loadingSolicitation = false;
        this.$forceUpdate();
      }
    },

    async getItems(useLoading = true) {
      try {
        this.error = null;
        this.loadingItems = useLoading;

        const contractsToGetLateSlips = [...this.allowedContracts];

        if (contractsToGetLateSlips.length > 0) {
          let promises = [
            this.$store.dispatch('lateSlips/getLateSolicitations'),
            this.$store.dispatch(
              'lateSlips/getLatePaymentSlips',
              contractsToGetLateSlips
            ),
          ];
          await Promise.all(promises);
        }
        let hasToReset = false;
        let unitSolicitations = this.unitSolicitations;
        for (const solicitation of unitSolicitations) {
          let hasSomethingToShow = false;

          if (solicitation.ready) {
            // Add barcode into parcel
            for (const item of solicitation.items) {
              item.ready = true;
              // item.barcode = null;
              for (const parcel of item.parcels) {
                const { barcode } =
                  this.latePositionData[item.contractId]['late'].find(
                    (s) =>
                      s.serieId === parcel.serieId &&
                      s.parcelCode === parcel.parcelCode
                  ) || {};
                if (!item.barcode && barcode) {
                  item.barcode = barcode;
                }
              }
            }

            this.solicitationsByContract[solicitation.contractId] =
              solicitation.items;
            this.selectedStep[solicitation.contractId] = '3';

            hasSomethingToShow = true;
          } else {
            let firstSolicitation = solicitation.items[0] || null;
            this.solicitationsByContract[solicitation.contractId] =
              firstSolicitation;

            if (solicitation.systemDischarge) {
              //? Período entre o pagamento e efetivação.
              this.systemDischarge[solicitation.contractId] = true;

              hasSomethingToShow = true;
            } else if (solicitation.inProgress || solicitation.error) {
              this.selectedStep[solicitation.contractId] = '2';
              if (solicitation.error) {
                this.solicitationErrors[solicitation.contractId] =
                  solicitation.error;
                hasToReset = true;
              }

              hasSomethingToShow = true;
            }
          }

          if (
            hasSomethingToShow &&
            this.solicitationsByContract[solicitation.contractId]
          ) {
            const contractIndex = contractsToGetLateSlips.findIndex(
              (o) => o.id === solicitation.contractId
            );
            if (contractIndex !== -1)
              contractsToGetLateSlips.splice(contractIndex, 1);
          }
        }
        this.error = null;
        if (hasToReset) {
          this.$store.dispatch('lateSlips/resetLateSlipsCache');
        }
        this.$forceUpdate();
      } catch (err) {
        console.error(err);
        this.error = true;
      } finally {
        this.loadingItems = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/breakpoint';

.waiting-state {
  &__title {
    margin: 0;
    font-weight: var(--font-weight);
  }
  &__text {
    margin: 0;
    font-size: 11px;
  }
}

.indelay-slips-tooltip {
  padding: 12px 0;
}

.table-stepper-container {
  padding: 16px;

  @include breakpoint(mobile) {
    padding: 0px;
  }
}

.payment-slip-in-delay {
  &__description {
    font-size: 12px;
    padding-bottom: 10px;
    color: var(--label-color);
  }
  &__febraban {
    font-size: var(--payment-slip-in-size);
    padding-bottom: 10px;
    color: var(--payment-slip-in-color);
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/financial/LatePaymentSlip.vue